// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgMobileIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M7.6 4.8a.8.8 0 0 1 .8-.8h7.2a.8.8 0 0 1 .8.8v14.4a.8.8 0 0 1-.8.8H8.4a.8.8 0 0 1-.8-.8zM8.4 2a2.8 2.8 0 0 0-2.8 2.8v14.4A2.8 2.8 0 0 0 8.4 22h7.2a2.8 2.8 0 0 0 2.8-2.8V4.8A2.8 2.8 0 0 0 15.6 2zm2.555 14.4a1 1 0 1 0 0 2h2.09a1 1 0 1 0 0-2z"
    />
  </g>
);
export default SvgMobileIcon;
SvgMobileIcon.displayName = 'SvgMobileIcon';
